import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const track = document.querySelector(".testimonials-carousel__track")
    const items = document.querySelectorAll(".testimonial-alt")
    const prev = document.querySelector(".prev")
    const next = document.querySelector(".next")

    const firstClone = items[0].cloneNode(true)
    const lastClone = items[items.length - 1].cloneNode(true)

    firstClone.classList.add("clone")
    lastClone.classList.add("clone")

    track.appendChild(firstClone)
    track.insertBefore(lastClone, items[0])

    const allItems = track.querySelectorAll(".testimonial-alt")
    const itemCount = allItems.length
    const itemWidth = allItems[0].offsetWidth + 10

    let index = 1
    let isTransitioning = false

    function updateSlidePosition(animate = true) {
      if (!animate) {
        track.style.transition = "none"
      } else {
        track.style.transition = "transform 0.4s ease"
      }
      track.style.transform = `translateX(${-index * itemWidth}px)`
    }

    function handleTransitionEnd() {
      if (allItems[index].classList.contains("clone")) {
        track.style.transition = "none"
        if (index === 0) {
          index = itemCount - 2
        } else if (index === itemCount - 1) {
          index = 1
        }
        track.style.transform = `translateX(${-index * itemWidth}px)`
        void track.offsetWidth
        track.style.transition = "transform 0.4s ease"
      }
      isTransitioning = false
    }

    next.addEventListener("click", () => {
      if (isTransitioning) return
      isTransitioning = true
      index++
      updateSlidePosition()
    })

    prev.addEventListener("click", () => {
      if (isTransitioning) return
      isTransitioning = true
      index--
      updateSlidePosition()
    })

    track.addEventListener("transitionend", handleTransitionEnd)

    updateSlidePosition(false)
  }
}
